import React from 'react';
import { Text, Section, Link } from '@react-email/components';
import Layout, { LayoutTranslations } from './components/Layout';

export interface PaymentApprovedTranslations {
  title: string;
  greeting: string;
  body: string;
  labelAmount: string;
  labelLevel: string;
  badgeActive: string;
  ctaText: string;
  signOff: string;
  teamSignature: string;
  layout: LayoutTranslations;
}

interface PaymentApprovedProps {
  name: string;
  amount: string;
  level: 'premium' | 'vip';
  translations: PaymentApprovedTranslations;
}

export default function PaymentApproved({
  name,
  amount,
  level,
  translations: tx,
}: PaymentApprovedProps) {
  const levelLabel = level === 'vip' ? 'VIP' : 'Premium';

  return (
    <Layout previewText={`${tx.title} - ${amount}`} translations={tx.layout}>
      <Text style={heading}>{tx.title}</Text>
      <Text style={paragraph}>{tx.greeting} <strong>{name}</strong>,</Text>
      <Text style={paragraph}>{tx.body.replace('{{level}}', levelLabel)}</Text>

      <Section style={infoBox}>
        <Text style={infoLine}>
          <span style={infoLabel}>{tx.labelAmount}:</span> {amount}
        </Text>
        <Text style={infoLine}>
          <span style={infoLabel}>{tx.labelLevel}:</span>{' '}
          <strong style={{ color: level === 'vip' ? '#d97706' : '#2563eb' }}>{levelLabel}</strong>
        </Text>
      </Section>

      <Section style={badgeSection}>
        <Text style={badgeText}>{tx.badgeActive}</Text>
      </Section>

      <Section style={ctaContainer}>
        <Link href="https://siportevent.com/visitor/dashboard" style={ctaButton}>
          {tx.ctaText}
        </Link>
      </Section>

      <Text style={paragraph}>{tx.signOff}<br />{tx.teamSignature}</Text>
    </Layout>
  );
}

const heading: React.CSSProperties = { fontSize: '24px', fontWeight: 700, color: '#059669', margin: '0 0 20px 0' };
const paragraph: React.CSSProperties = { fontSize: '16px', lineHeight: '1.6', color: '#374151', margin: '0 0 16px 0' };
const infoBox: React.CSSProperties = { backgroundColor: '#ecfdf5', padding: '20px', borderRadius: '8px', margin: '20px 0', border: '1px solid #a7f3d0' };
const infoLine: React.CSSProperties = { fontSize: '15px', color: '#1f2937', margin: '0 0 10px 0' };
const infoLabel: React.CSSProperties = { color: '#6b7280' };
const badgeSection: React.CSSProperties = { textAlign: 'center' as const, margin: '20px 0' };
const badgeText: React.CSSProperties = { display: 'inline-block', padding: '10px 24px', backgroundColor: '#059669', color: '#ffffff', borderRadius: '20px', fontWeight: 600, fontSize: '14px' };
const ctaContainer: React.CSSProperties = { textAlign: 'center' as const, margin: '30px 0' };
const ctaButton: React.CSSProperties = { display: 'inline-block', padding: '14px 28px', backgroundColor: '#059669', color: '#ffffff', textDecoration: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '16px' };
